export default __webpack_public_path__ + "4c1dd175a747532aeb6a09828ac47e85.png";